import React, {
  useContext,
  useEffect,
  useState,
} from "react";

import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";

import { FiPlus, FiRefreshCcw } from "react-icons/fi";

import PageTitle from "components/Typography/PageTitle";
import MainDrawer from "components/drawer/MainDrawer";
import VendorRatesDrawer from "components/drawer/VendorRatesDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import Loader from "components/form/Loader";
import VendorRatesSubmittedTable from "components/vendor/VendorRatesSubmittedTable";

import sidebar from "routes/sidebar";

import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import useToggleDrawer from "hooks/useToggleDrawer";

import { SidebarContext } from "context/SidebarContext";

import VendorRatesServices from "services/VendorRatesServices";

const VendorRatesPage = () => {
  const adminInfo = JSON.parse(
    localStorage.getItem("adminInfo")
  );

  const [searchText, setSearchText] = useState("");

  const {
    data,
    loading,
    error,
  } = useAsync(
    VendorRatesServices.getAllVendorRates
  );


  const safeData = Array.isArray(data?.data)
    ? data.data
    : [];

  const filteredData = safeData.filter((item) => {
    const search = searchText.toLowerCase().trim();

    return (
      item?.vendor_name
        ?.toLowerCase()
        .includes(search) ||
      item?.phone_number
        ?.toString()
        .toLowerCase()
        .includes(search) ||
      item?.state_name
        ?.toLowerCase()
        .includes(search)
    );
  });

  const [itemsPerPage, setItemsPerPage] =
    useState(100);

  const {
    vendorRef,
    dataTable,
    currentPage,
  } = useFilter(filteredData, itemsPerPage);

  const {
    toggleDrawer,
    functionLoading,
    setIsUpdate,
  } = useContext(SidebarContext);

  const {
    title,
    serviceId,
  } = useToggleDrawer();


  useEffect(() => {
    setItemsPerPage(filteredData.length || 100);
  }, [filteredData]);


  return (
    <>
      <DeleteModal
        id={serviceId}
        title={title}
      />

      <MainDrawer>
        <VendorRatesDrawer id={serviceId} />
      </MainDrawer>

      <PageTitle
        sidebar={sidebar().sidebar}
      />

      <Card className="mb-5">

        <CardBody>

          <div className="flex items-center gap-4">

            <div className="flex-1">
              {/* <Input
                ref={vendorRef}
                className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                type="search"
                name="search"
                placeholder="Quick Search"
                autoComplete="off"
                onChange={handleSubmitVendor}
              /> */}

              <Input
                ref={vendorRef}
                className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                type="search"
                name="search"
                value={searchText}
                placeholder="Quick Search"
                autoComplete="off"
                onChange={(e) => setSearchText(e.target.value)}
              />

            </div>

            <Button
              onClick={toggleDrawer}
            >
              <FiPlus className="mr-2" />
              Create Vendor Link
            </Button>

            {/* <ExportDataXlsx
              title="Vendor Rate Sheet"
              fileNames="Vendor Rate Sheet"
              exportDataXlsx={updatedData}
              id_employee={
                adminInfo?.id
              }
            /> */}

            <FiRefreshCcw
              size={22}
              className="cursor-pointer"
              onClick={() =>
                setIsUpdate(true)
              }
            />

          </div>

        </CardBody>

      </Card>

      {functionLoading && (
        <Loader message="Loading..." />
      )}

      <TableContainer>

        <div
          style={{
            maxHeight: "70vh",
            overflowY: "auto",
          }}
        >

          <Table>

            <TableHeader className="sticky top-0 bg-white z-20">

              <tr>

                <TableCell className="text-center">
                  Sl.No
                </TableCell>

                <TableCell className="text-center">
                  Vendor Name
                </TableCell>

                <TableCell className="text-center">
                  State
                </TableCell>

                {/* <TableCell className="text-center">
                  Phone
                </TableCell> */}

                <TableCell className="text-center">
                  Submitted Date
                </TableCell>

                {/* <TableCell className="text-center">
                  Submitted Time
                </TableCell> */}

                <TableCell className="text-center">
                  Link
                </TableCell>

                <TableCell className="text-center">
                  Status
                </TableCell>

                <TableCell className="text-center">
                  Action
                </TableCell>

              </tr>

            </TableHeader>

            <VendorRatesSubmittedTable
              VendorRatesData={
                dataTable
              }
              perpage={
                itemsPerPage
              }
              currentPage={
                currentPage
              }
            />

          </Table>

        </div>

      </TableContainer>

    </>
  );
};

export default VendorRatesPage;